export { default } from "./amazon-native-ad"